module.exports = __webpack_public_path__ + "static/media/uib4.417471d8.png";